export const callbackOutUrlField = 'callbackOutUrl'
export const callbackInUrlField = 'callbackInUrl'
export const formatField = 'format'
export const ipListField = 'ipList'
export const passwordField = 'password'
